/**
 * Catch-all Not Found Route
 *
 * Expo Router automatically renders this for any URL that doesn't match a
 * route in the app, replacing the default "Unmatched Route" screen (which
 * exposes a link to the `/_sitemap` debug page). Keep this in sync with
 * `not-found.tsx`, which is the same UI reached via an explicit redirect.
 */

import { NotFoundContent } from "@src/components/NotFoundContent";

export default function CatchAllNotFoundScreen() {
  return <NotFoundContent />;
}
